import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { PaginationProps, Switch, TreeSelect } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { memo, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ICustomer } from '../../../../../api/Customer_V2/customerApi_V2';
import { editCustomerByGroup, getDetailGroup, getListAllCustomer, getListConditionMatched, getListConditionUnMatched, getListCustomerByGroup, getListOperatorFieldGroup, IDetailGroup, IOperatorFieldGroup, IOperatorFieldGroupV2, IVConditionFilterADD, IVConditionFilterV2, updateListGroup, updateOperatorFilterGroup } from '../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { getListCarCompany, ISelectOption } from '../../../../../api/selectOptions/selectOptionsApi';
import { filterInfoOperatoToConditions } from '../../../../../apiSync/customerGroup/customerGroupApi';
import { group_share, group_share_active, user_private, user_private_active } from '../../../../../components/ExportImgFigma';
import useDebounce from '../../../../../hook/useDebounce';
import useLoading from '../../../../../hook/useLoading';
import useThrottle from '../../../../../hook/useThrottle';
import { selectorInfoUser } from '../../../../../store/slices/infoUserSlice';
import { fommatSelectOption, getLastIdList, getLastPriorityList } from '../../../../../until';
import { convertTreeForAntd, EDisplayGroupType, useCustomerGroupContext } from '../../indexV2';
import '../../style.scss';
import { gListOperatorFieldConditionsGroupByInfo } from '../../untilGroupCustomer';
import { CONDITION, dataDefaulFilterList, generateColumnsFromCodesAgGridReactGroup, IDataFilterGroupList, ILastIdGroupCustomer, TypeConditionPreview } from '../AddGroup/AddNewGroup';
import { CONDITIONGROUP } from '../AddGroup/Component/PrivateGroup/AG_PrivateAutomatic';
import ModalAddAndEditCondition, { initInfoOperator, toAddPayload } from '../Modal/ModalAddAndEditCondition';
import EG_ConditionComponent from './ConditionEdit/EG_ConditionComponent';
import { ISelectedUserAccount } from './ConditionEdit/EG_Decentralization';
import EG_PrivateNoAutomatic from './PrivateEditGroup/EG_PrivateNoAutomatic';
import EG_SharingNoAutomatic from './SharingEditGroup/EG_SharingNoAutomatic';
import { NO_DATA, NO_VIEW } from '../../../../../services/data';
import { selectLoading } from '../../../../../store/slices/loadingSlice';
import useToast from '../../../../../hook/useToast';
import { selectorCategoryCarIds } from '../../../../../store/slices/categoryCarSlice';
import { BATCH_SIZE } from '../../../../../env';
import { buildOptions } from '../../../../CustomersV2/indexV2';
import { ColDef } from 'ag-grid-community';


export enum GROUPTYPE {
    PRIVATE = 0,   // Nhóm riêng tư
    SHARED = 1,    // Nhóm chia sẻ
}
const initDetailGroup: IDetailGroup = {
    id: 0,
    title: "",
    description: "",
    type: 0,
    status: 0,
    delf: 0,
    role: 0,
    parentId: 0,
    level: 0,
    adminId: 0,
    adminName: "",
    dateCreate: "",   // có thể dùng new Date().toISOString() nếu cần giá trị mặc định là ngày hiện tại
    listCustomer: [],
    listAdmin: [],
}

export enum AddType {
    Manual = 0,   // Thêm thủ công
    Auto = 1      // Thêm tự động
}

// Định nghĩa interface sử dụng enum
export interface ISelectedCustomer {
    customerId: number;
    addType: AddType;
}


// Định nghĩa interface sử dụng enum
export interface ISelectedCustomerV2 {
    id: number;
    addType: AddType;
}



// ── Serialize conditions cho so sánh ──────────────────────────────────────────
const serializeConditions = (info: IVConditionFilterV2): string => {
    const active = info.conditions
        .filter(c => c.isAdd === true)
        .map(c => ({
            lo: c.logicOperator,
            f: c.CustomerField?.fieldCode,
            co: c.condition?.value,
            v: c.value,
        }));
    return JSON.stringify({ t: info.typeCondition, c: active });
};

const EditGroup = () => {
    useEffect(() => {
        return () => {

            setSelectedIdCustomerV9([])
            setSelectedIdNoCondCustomerManual(new Set())
            setSelectedIdCondUnmatchedCustomers(new Set())

            setInfoOriginIdByFilterSync({ matched: [], unMatched: [] })
        }
    }, [])

    const pushLoading = useLoading()
    const pushToast = useToast();
    const navigator = useNavigate()
    const { unitTemp, unit } = useSelector(selectorInfoUser)
    const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)
    const isLoading = useSelector(selectLoading)



    const {
        infoOperator,
        isModalLoadingSync,
        isLoadingListUnmatchedSync,
        sLCategoryCar,
        displayType, inforNodeEvent,
        dataFieldsActive, ColumnsMapShow, listGroup,
        setInfoOperator,
        setIsModalLoadingSync, setIsLoadingListUnmatchedSync,
        setInforNodeEvent,
        onSubmitFormModalUpdate,
    } = useCustomerGroupContext();

    const skipCondMatchedRef = useRef(false);
    // Snapshot KH addType=1 lấy từ API lần đầu — dùng để detect KH bị bỏ checkbox
    const initialAutoCustomersRef = useRef<Set<number>>(new Set());

    // ── Edit tracking ────────────────────────────────────────────────────
    const [isCustomerModified, setIsCustomerModified] = useState(false);
    const initialAllCustomersRef = useRef<Set<number>>(new Set());
    const initialConditionRef = useRef<string>('');
    const isInitialCondLoadRef = useRef(false);

    const [isLoadingTableModal, setIsLoadingTableModal] = useState<boolean>(false)

    const [isModalCondition, setModalCondition] = useState<boolean>(false)
    const [searchListFilter, setSearchListFilter] = useState<string>('')

    const [sLOperatorFieldGroup, setSLOperatorFieldGroup] = useState<IOperatorFieldGroupV2[]>([])

    const [paginationCustomer, setPaginationCustomer] = useState({ current: 1, pageSize: 10, total: 0 });

    // const [selectedIdCustomer, setSelectedIdCustomer] = useState<Set<number>>(new Set());

    const [selectedIdCustomerV9, setSelectedIdCustomerV9] = useState<ISelectedCustomer[]>([]);

    const [selectedIdAccount, setSelectedIdAccount] = useState<ISelectedUserAccount[]>([]);
    const [idCustomerLast, setIdCustomerLast] = useState<{ condUnmatched?: number, condMatched?: number }>({ condUnmatched: undefined, condMatched: undefined });


    const [inforGroup, setInforGroup] = useState<IDetailGroup>(initDetailGroup)

    const [lastId, setLastId] = useState<ILastIdGroupCustomer>()
    const [lastPriority, setLastPriority] = useState<ILastIdGroupCustomer>()


    //Kh không dk--------------------
    const [paginationNoCondCustomerManual, setPaginationNoCondCustomerManual] = useState({ current: 1, pageSize: 10, total: 0 });

    const [dataFilterListNoCondCustomers, setDataFilterListNoCondCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)
    const [dataFilterListNoCondCustomerManual, setDataFilterListNoCondCustomerManual] = useState<IDataFilterGroupList>(dataDefaulFilterList)

    const [listCustomerNoCondCustomers, setlistCustomerNoCondCustomers] = useState<any[]>([])
    const [selectedIdNoCondCustomerManual, setSelectedIdNoCondCustomerManual] = useState<Set<number>>(new Set());
    const [listNoCondCustomerManual, setListNoCondCustomerManual] = useState<any[]>([])

    //Kh không dk--------------------


    //Kh có dk---------

    const [paginationCondMatchedCustomers, setPaginationCondMatchedCustomers] = useState({ current: 1, pageSize: 10, total: 0 });
    const [paginationCondUnmatchedCustomers, setPaginationCondUnmatchedCustomers] = useState({ current: 1, pageSize: 10, total: 0 });
    const [dataFilterListCondUnmatchedCustomers, setDataFilterListCondUnmatchedCustomers] = useState<IDataFilterGroupList>(dataDefaulFilterList)

    const [selectedIdCondUnmatchedCustomers, setSelectedIdCondUnmatchedCustomers] = useState<Set<number>>(new Set());


    const [matchedCondCustomers, setMatchedCondCustomers] = useState<number[]>([]);
    const [infoOriginIdByFilterSync, setInfoOriginIdByFilterSync] =
        useState<{ matched: number[], unMatched: number[] }>({ matched: [], unMatched: [] });

    const [listCondMatchedCustomers, setListCondMatchedCustomers] = useState<ICustomer[]>([])
    const [listCondUnmatchedCustomers, setListCondUnmatchedCustomers] = useState<ICustomer[]>([])
    //Kh có dk---------

    //Kh có dk all
    const [paginationCondAll, setPaginationCondAll] = useState({ current: 1, pageSize: 10, total: 0 });
    const [listCondCustomerAll, setlistCondCustomerAll] = useState<any[]>([])

    //Kh có dk all

    //Kh không dk

    const actionColumn: ColDef = {
        headerName: 'Nguồn',
        width: 110,
        resizable: false,
        pinned: 'left',
        suppressMovable: true,
        lockPosition: 'left',
        cellRenderer: (params: any) => {
            return !params.data.addType ?
                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            height: '30px',
                            padding: '2px 8px',
                            backgroundColor: '#F6FFED',
                            color: '#52C41A',
                            border: '1px solid #52C41A',
                            fontSize: 14
                        }}
                    >

                        <span>Thủ công</span>
                    </div>
                </div >

                :

                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            height: '30px',
                            padding: '2px 8px',
                            backgroundColor: '#E6F7FF',
                            color: '#40A9FF',
                            border: '1px solid #40A9FF',
                            fontSize: 14
                        }}
                    >

                        <span>Điều kiện</span>
                    </div>
                </div >
        }

    }


    const memoizedColumnDefs = useMemo(() => {
        return generateColumnsFromCodesAgGridReactGroup(
            ColumnsMapShow, dataFieldsActive, actionColumn,
            (id: number, next: boolean, rowData: any) =>
                navigator(
                    `/customer/list/edit`,
                    {
                        state: {
                            firstPage: "/customer/group",
                            id: rowData?.data?.id,
                            inforNodeEvent: {
                                ...inforNodeEvent,
                                action: "view",
                            }
                        }
                    }
                ),

            ['own_vehicle_brand', 'own_vehicle_type_category', 'own_vehicle_model', 'own_vehicle_name', 'own_vehicle_color']
        );
    }, [ColumnsMapShow, inforGroup, listCustomerNoCondCustomers, listNoCondCustomerManual, listCondMatchedCustomers, inforNodeEvent]);

    const tableDataNoCondCustomer: any[] = useMemo(() => {
        return listCustomerNoCondCustomers.map((item) => {
            const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
                acc[field.fieldCode] = field.view ? field.value : NO_VIEW
                return acc
            }, {})
            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            }
        })
    }, [listCustomerNoCondCustomers])

    const tableDataCondCustomerAll: any[] = useMemo(() => {
        return listCondCustomerAll.map((item) => {
            const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
                acc[field.fieldCode] = field.view ? field.value : NO_VIEW
                return acc
            }, {})
            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            }
        })
    }, [listCondCustomerAll])

    //ds kh thêm thủ công không dk
    const tableDataNoCondCustomerManual: any[] = useMemo(() => {
        return listNoCondCustomerManual.map((item) => {
            const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
                acc[field.fieldCode] = field.view ? field.value : NO_VIEW
                return acc
            }, {})
            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            }
        })
    }, [listNoCondCustomerManual])


    const tableDataCondMatchedCustomers: any[] = useMemo(() => {
        return listCondMatchedCustomers.map((item) => {
            const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
                acc[field.fieldCode] = field.view ? field.value : NO_VIEW
                return acc
            }, {})
            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            }
        })
    }, [listCondMatchedCustomers])

    const tableDataCondUnmatchedCustomers: any[] = useMemo(() => {
        return listCondUnmatchedCustomers.map((item) => {
            const fieldValues = item.fields.reduce((acc: Record<string, any>, field: any) => {
                acc[field.fieldCode] = field.view ? field.value : NO_VIEW
                return acc
            }, {})
            return {
                ...item,
                key: item.id.toString(),
                ...fieldValues,
            }
        })
    }, [listCondUnmatchedCustomers])



    const gInforGroup = async (id: number, unitTemp: number) => {
        const result = await getDetailGroup(permittedCategoryCarIds, id, unitTemp)
        if (result?.status) {
            const { type, status, listCustomer } = result.data
            const initialList = listCustomer.map((customerId: number) => ({
                customerId,
                addType: type as AddType,
            }));
            setSelectedIdCustomerV9(initialList);

            // Lưu snapshot KH addType=1 từ API để so sánh khi save
            if (type === AddType.Auto) {
                initialAutoCustomersRef.current = new Set(listCustomer);
            } else {
                initialAutoCustomersRef.current = new Set();
            }

            setInforGroup(result.data)

            // ── Lưu initial data cho Edit tracking ──
            initialAllCustomersRef.current = new Set(listCustomer);
            setIsCustomerModified(false);

            if (result.data.infoFilter) {
                const infoNew = await gListOperatorFieldConditionsGroupByInfo(result.data.infoFilter, unitTemp);
                isInitialCondLoadRef.current = true;
                setInfoOperator(infoNew);
                // initialConditionRef sẽ được set trong conditions useEffect
            } else {
                // Nhóm không có điều kiện
                initialConditionRef.current = serializeConditions(initInfoOperator);
                isInitialCondLoadRef.current = false;
            }
        } else {
            // pushToast(result?.message, "warning")
        }
    }

    const gListCustomer = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        pushLoading(true)
        const {
            listCategoryCar, listUnit, search
        } = dataFilterListNoCondCustomers

        const lastIdTmp = pageCurent === 1 ? undefined : lastId
        const lastPriorityTmp = pageCurent === 1 ? undefined : lastPriority

        const result = await getListCustomerByGroup(
            permittedCategoryCarIds,
            pageSize, pageCurent, search, unitTemp ?? undefined,
            // listUnit, listCategoryCar, inforGroup?.id, undefined,
            listUnit, listCategoryCar, inforGroup?.id, 1,
            undefined, Array.from(selectedIdNoCondCustomerManual), lastIdTmp?.noCond, lastPriorityTmp?.noCond
        )
        if (result?.status) {
            // console.log(result.data)
            setlistCustomerNoCondCustomers(result.data)
            setPaginationCustomer({ current: pageCurent, total: result.total, pageSize })

            setLastId({ ...lastId, noCond: getLastIdList(result.data) })
            setLastPriority({ ...lastPriority, noCond: getLastPriorityList(result.data) })
        } else {
            // pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)


    //Kh không dk
    const gListNoCondCustomerManual = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        pushLoading(true)
        const {
            listCategoryCar, listUnit, search
        } = dataFilterListNoCondCustomerManual

        const lastIdTmp = pageCurent === 1 ? undefined : lastId

        const result = await getListCustomerByGroup(
            permittedCategoryCarIds,
            pageSize, pageCurent, search, unitTemp ?? undefined,
            listUnit, listCategoryCar, inforGroup?.id, 1,
            undefined, undefined, lastIdTmp?.noCond
        )
        if (result?.status) {
            setListNoCondCustomerManual(result.data)
            setPaginationNoCondCustomerManual({ current: pageCurent, total: result.total, pageSize })

            setLastId({ ...lastId, noCond: getLastIdList(result.data) })
        } else {
            // pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)

    //Lấy ds kh xem trước dk All
    const gListCustomerCondAll = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
        const lastIdTmp = pageCurent === 1 ? undefined : lastId
        const lastPriorityTmp = pageCurent === 1 ? undefined : lastPriority

        pushLoading(true)
        const result = await getListCustomerByGroup(
            permittedCategoryCarIds,
            pageSize, pageCurent, undefined, undefined,
            undefined, undefined, undefined, undefined,
            undefined, undefined, lastIdTmp?.noCond, lastPriorityTmp?.noCond
        )
        if (result?.status) {

            setlistCondCustomerAll(result.data)
            setPaginationCondAll({ current: pageCurent, total: result.total, pageSize })

            setLastId({ ...lastId, noCond: getLastIdList(result.data) })
            setLastPriority({ ...lastPriority, noCond: getLastPriorityList(result.data) })
        } else {
            // pushToast(result?.message, "warning")
        }
        pushLoading(false)
    }, 1000)

    //Lấy ra toàn bộ api thảo và k thỏa dk xem trước dk
    const gSyncListCustomerGroupByFilter = useDebounce(async (
        typeConditionPreview: TypeConditionPreview, pageCurent: number = 1, pageSize: number = 20
    ) => {
        setIsModalLoadingSync(true)
        const conditions = filterInfoOperatoToConditions(infoOperator)
        const listUnmatchedCustomers =
            (typeConditionPreview !== "filter" || !skipCondMatchedRef.current) ?
                Array.from(selectedIdCondUnmatchedCustomers) :
                undefined
        const dataFilter = typeConditionPreview === "condUnmatched" ? dataFilterListCondUnmatchedCustomers : undefined;

        const lastIdTmp = pageCurent === 1 ? undefined : lastId
        switch (typeConditionPreview) {
            case "filter": {
                setIsModalLoadingSync(true)
                const [resultFilterCondMatched, resultAllCustomer] = await Promise.all([
                    getListConditionMatched(
                        permittedCategoryCarIds, conditions,
                        pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
                        inforGroup?.id, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
                        lastIdTmp?.condMatched
                    ),
                    getListAllCustomer(
                        permittedCategoryCarIds,
                        unitTemp, conditions, inforGroup?.id, undefined
                    )

                ])

                if (resultFilterCondMatched.status) {
                    setListCondMatchedCustomers(resultFilterCondMatched.data.dataMatched)
                    setPaginationCondMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })
                } else {
                    pushToast(resultFilterCondMatched?.message, 'warning')
                }
                setIsModalLoadingSync(false)

                if (resultAllCustomer.status) {
                    setSelectedIdCustomerV9(resultAllCustomer.data);

                    initialAutoCustomersRef.current = new Set(
                        resultAllCustomer.data
                            .filter((c: ISelectedCustomer) => c.addType === AddType.Auto)
                            .map((c: ISelectedCustomer) => c.customerId)
                    );
                    // Đóng vì lỗi khi mở modal lần đầu tiên bị dính select hiển thị dù chưa dc chọn
                    // const manualIds = new Set(
                    //     resultAllCustomer.data
                    //         .filter((c: ISelectedCustomer) => c.addType === AddType.Manual)
                    //         .map((c: ISelectedCustomer) => c.customerId)
                    // );
                    // setSelectedIdCondUnmatchedCustomers(manualIds);
                } else {
                    pushToast(resultAllCustomer?.message, 'warning')
                }
                setIsModalLoadingSync(false)

                //
                setIsLoadingListUnmatchedSync(true)
                setIsLoadingTableModal(true)
                const resultFilterCondUnMatched = await getListConditionUnMatched(
                    permittedCategoryCarIds, conditions,
                    pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
                    inforGroup?.id, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
                    lastIdTmp?.condUnmatched
                )
                if (!resultFilterCondUnMatched) {
                    setIsLoadingListUnmatchedSync(false)
                    setIsLoadingTableModal(false)
                    break;
                }
                if (resultFilterCondUnMatched.status) {
                    setListCondUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
                    setPaginationCondUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

                } else {
                    pushToast(resultFilterCondUnMatched?.message, 'warning')
                }
                setIsLoadingListUnmatchedSync(false)
                setIsLoadingTableModal(false)
                gListAllCustomer(false)
                setLastId({
                    ...lastId,
                    condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched),
                    condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched)
                })

                break;
            }
            case "condMatched": {
                setIsModalLoadingSync(true)
                const resultFilterCondMatched = await getListConditionMatched(
                    permittedCategoryCarIds,
                    conditions,
                    pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
                    inforGroup?.id, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
                    lastIdTmp?.condMatched
                )
                if (resultFilterCondMatched.status) {
                    setListCondMatchedCustomers(resultFilterCondMatched.data.dataMatched)
                    setPaginationCondMatchedCustomers({ current: pageCurent, total: resultFilterCondMatched.data.totalMatched, pageSize })

                    setLastId({ ...lastId, condMatched: getLastIdList(resultFilterCondMatched.data.dataMatched) })
                } else {
                    pushToast(resultFilterCondMatched?.message, 'warning')
                }
                setIsModalLoadingSync(false)
                break;
            }
            case "condUnmatched": {
                setIsLoadingTableModal(true)
                const resultFilterCondUnMatched = await getListConditionUnMatched(
                    permittedCategoryCarIds, conditions,
                    pageSize, pageCurent, dataFilter?.search, unitTemp ?? undefined,
                    inforGroup?.id, listUnmatchedCustomers, dataFilter?.listUnit, dataFilter?.listCategoryCar,
                    lastIdTmp?.condUnmatched
                )
                if (!resultFilterCondUnMatched) {
                    setIsLoadingTableModal(false)
                    break;
                }
                if (resultFilterCondUnMatched.status) {
                    setListCondUnmatchedCustomers(resultFilterCondUnMatched.data.dataUnmatched)
                    setPaginationCondUnmatchedCustomers({ current: pageCurent, total: resultFilterCondUnMatched.data.totalUnmatched, pageSize })

                    setLastId({ ...lastId, condUnmatched: getLastIdList(resultFilterCondUnMatched.data.dataUnmatched) })
                } else {
                    pushToast(resultFilterCondUnMatched?.message, 'warning')
                }
                setIsLoadingTableModal(false)
                break;
            }

            default:
                break;
        }
        setIsModalLoadingSync(false)

        // Tắt cờ sau khi filter tải xong
        skipCondMatchedRef.current = false;
    }, 2000)

    const removeNodeById = (nodes: any[], idToRemove: number): any[] => {
        return nodes
            .filter(node => {
                return Number(node.value) !== idToRemove; // loại bỏ node khớp id
            })
            .map(node => ({
                ...node,
                children: node.children ? removeNodeById(node.children, idToRemove) : [],
            }));
    };

    const handleChange = (field: keyof IDetailGroup, value: any) => {
        if (!inforGroup) return; // tránh lỗi undefined
        setInforGroup({
            ...inforGroup,
            [field]: value,
        });
    };

    const handleSwitch = (value: number) => {
        if (value === CONDITION.NO) {
            setModalCondition(true)
        } else {
            setInforGroup({ ...inforGroup, type: CONDITION.NO })
            setInfoOperator(initInfoOperator)
        }
    }

    // const editCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], idGroup: number) => {
    //     for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
    //         const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

    //         await editCustomerByGroup(chunk, idGroup); // gọi API từng batch

    //         await new Promise(r => setTimeout(r, 50)); // tránh nghẽn
    //         console.log('Processed chunk:', i)
    //     }
    // };

    const editCustomersInChunks = async (selectedIdCustomerV9: ISelectedCustomer[], idGroup: number) => {
        for (let i = 0; i < selectedIdCustomerV9.length; i += BATCH_SIZE) {
            const chunk = selectedIdCustomerV9.slice(i, i + BATCH_SIZE);

            let success = false;
            let retryCount = 0;

            while (!success) {
                try {
                    await editCustomerByGroup(chunk, idGroup);
                    success = true;
                } catch (error) {
                    retryCount++;
                    console.error(`Chunk ${i / BATCH_SIZE + 1} failed (retry ${retryCount})`, error);

                    // delay trước khi retry
                    await new Promise(r => setTimeout(r, 1000));
                }
            }

            // delay giữa các batch
            await new Promise(r => setTimeout(r, 50));
        }
    };

    const updateGroup = useThrottle(async () => {
        if (!inforGroup?.title || inforGroup?.title.trim() === "") {
            onSubmitFormModalUpdate(false, "Tên nhóm không được để trống"!)
            return;
        }
        pushLoading(true)
        const { id, title, status, type, description, parentId } = inforGroup

        // Build payload cho editCustomerByGroup
        const currentAutoIds = new Set(
            selectedIdCustomerV9
                .filter(c => c.addType === AddType.Auto)
                .map(c => c.customerId)
        );

        const payload: ISelectedCustomer[] = [
            // KH addType=0: giữ nguyên logic cũ (chỉ gửi những KH còn trong mảng)
            ...selectedIdCustomerV9.filter(c => c.addType === AddType.Manual),

            // KH addType=1 còn trong mảng: isDelete = 1 (active)
            ...selectedIdCustomerV9
                .filter(c => c.addType === AddType.Auto)
                .map(c => ({ ...c, isDeleted: 1 as const })),

            // KH addType=1 bị bỏ checkbox (có trong snapshot nhưng không còn trong state hiện tại)
            ...[...initialAutoCustomersRef.current]
                .filter(id => !currentAutoIds.has(id))
                .map(customerId => ({
                    customerId,
                    addType: AddType.Auto,
                    isDeleted: 0 as const,
                })),
        ];

        const listIdAddManual = [...new Set(
            payload.filter(c => c.addType === AddType.Manual).map(c => c.customerId)
        )];

        // ── listIdRemoved: Edit logic vs AddNew logic ──
        const isConditionChanged = serializeConditions(infoOperator) !== initialConditionRef.current;
        const useEditLogic = !isConditionChanged;

        let listIdRemoved: number[];
        if (useEditLogic) {
            // Edit logic: bất kỳ KH nào trong data ban đầu mà không còn trong selection hiện tại
            // Bao gồm cả addType=0 và addType=1
            const currentIds = new Set(selectedIdCustomerV9.map(c => c.customerId));
            listIdRemoved = [...initialAllCustomersRef.current].filter(cid => !currentIds.has(cid));
        } else {
            // AddNew logic: chỉ KH auto bị bỏ chọn (từ snapshot sau khi condition thay đổi)
            listIdRemoved = [...new Set(
                payload.filter(c => c.addType === AddType.Auto && (c as any).isDeleted === 0).map(c => c.customerId)
            )];
        }

        // ── Debug logs ──
        // console.log('[EditGroup] isCustomerModified:', isCustomerModified);
        // console.log('[EditGroup] isConditionChanged:', isConditionChanged);
        // console.log('[EditGroup] useEditLogic:', useEditLogic);
        // console.log('[EditGroup] initialCustomerIds:', [...initialAllCustomersRef.current]);
        // console.log('[EditGroup] initialCondition:', initialConditionRef.current);
        // console.log('[EditGroup] currentCondition:', serializeConditions(infoOperator));
        // console.log('[EditGroup] KH không thỏa điều kiện - chọn thủ công:', listIdAddManual);
        // console.log('[EditGroup] listIdRemoved:', listIdRemoved);
        // console.log('[EditGroup] listIdRemoved detail:', listIdRemoved.map(rid => ({
        //     customerId: rid,
        //     initialData: initialAllCustomersRef.current.has(rid),
        // })));

        // return
        const conditions = filterInfoOperatoToConditions(infoOperator)

        const result = await updateListGroup(
            id, title, type, status,
            selectedIdAccount, description, parentId, payload.length ?? 0,
            conditions, listIdAddManual, listIdRemoved, isCustomerModified
        )
        if (result?.status) {

            // await editCustomersInChunks(payload, id)

            if (inforGroup.type) {
                const filteredInfoOperatorADD = toAddPayload(infoOperator)
                const listFilterGroup: IVConditionFilterADD = {
                    typeCondition: filteredInfoOperatorADD.typeCondition,
                    conditions: filteredInfoOperatorADD.conditions
                };
                const resultFilter = await updateOperatorFilterGroup(
                    id, [listFilterGroup]
                )
                if (resultFilter?.status) {
                    onSubmitFormModalUpdate(true, result?.message)
                } else {
                    onSubmitFormModalUpdate(false, resultFilter?.message)
                }
            } else {
                onSubmitFormModalUpdate(true, result?.message)
            }
        } else {
            onSubmitFormModalUpdate(false, result?.message)
        }
        pushLoading(false)
    }, 1000)

    const cancelUpdateGroup = useThrottle(async () => {
        setInforNodeEvent(undefined)
        // setSelectedIdCustomer(new Set())

        setSelectedIdCustomerV9([])
    }, 1000)

    //Kh không dk  ds xem trước
    const handleChangeNoCondSelectIdCustomerView: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>> = (value) => {
        setIsCustomerModified(true);
        // Chuẩn hoá về mảng ISelectedCustomer[]
        const nextArray =
            typeof value === 'function'
                ? value(selectedIdCustomerV9) // selectedIdCustomerV9: state hiện tại
                : value;

        // Lấy danh sách customerId từ mảng value
        const valueIds = new Set(nextArray.map(v => v.customerId));

        // Giả sử selectedIdNoCondCustomerManual vẫn là Set<number>
        const nextB = new Set(
            [...selectedIdNoCondCustomerManual].filter(x => valueIds.has(x))
        );

        // Cập nhật state chính
        setSelectedIdCustomerV9(value);

        // Kiểm tra hai Set có giống nhau không
        const areSetsEqual =
            selectedIdNoCondCustomerManual.size === nextB.size &&
            [...selectedIdNoCondCustomerManual].every(v => nextB.has(v));

        if (!areSetsEqual) {
            setSelectedIdNoCondCustomerManual(nextB);
        }
    }

    //Kh không dk
    const handleChangeNoCondSelectIdCustomerManual = (value: Set<number>) => {
        setIsCustomerModified(true);
        setSelectedIdCustomerV9(prev => {
            // Map theo customerId để dễ union, tránh trùng
            const byId = new Map<number, ISelectedCustomer>(
                prev.map(c => [c.customerId, c])
            );

            // Thêm các id mới từ Set<number>
            value.forEach(id => {
                if (!byId.has(id)) {
                    byId.set(id, { customerId: id, addType: AddType.Manual });
                    // hoặc AddType.Auto tuỳ ngữ cảnh
                }
            });

            // Trả về mảng ISelectedCustomer[] đúng kiểu cho state
            return Array.from(byId.values());
        });

        // Phần này giữ nguyên như bạn muốn
        setSelectedIdNoCondCustomerManual(value);
    }

    //Kh có dk ds xem trước
    const handleChangeCondSelectIdCustomerView: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>> = (value) => {
        setIsCustomerModified(true);
        // Chuẩn hoá về mảng ISelectedCustomer[]
        const nextArray =
            typeof value === 'function'
                ? value(selectedIdCustomerV9) // selectedIdCustomerV9: state hiện tại
                : value;

        // Lấy danh sách customerId từ mảng value
        const valueIds = new Set(nextArray.map(v => v.customerId));

        // Giả sử selectedIdNoCondCustomerManual vẫn là Set<number>
        const nextB = new Set(
            [...selectedIdCondUnmatchedCustomers].filter(x => valueIds.has(x))
        );

        // Cập nhật state chính
        setSelectedIdCustomerV9(value);

        // Kiểm tra hai Set có giống nhau không
        const areSetsEqual =
            selectedIdCondUnmatchedCustomers.size === nextB.size &&
            [...selectedIdCondUnmatchedCustomers].every(v => nextB.has(v));

        if (!areSetsEqual) {
            setSelectedIdCondUnmatchedCustomers(nextB);
        }
    }

    //Kh có dk
    const handleChangeCondSelectIdCustomerManual = (value: Set<number>) => {
        setIsCustomerModified(true);
        // 1) Cập nhật danh sách selectedIdCustomerV9 (thêm + xóa theo diff)
        setSelectedIdCustomerV9(prevList => {
            // Tìm các id bị bỏ chọn (có trong selectedIdCondUnmatchedCustomers nhưng không còn trong value)
            const removedIds = new Set<number>();
            selectedIdCondUnmatchedCustomers.forEach(id => {
                if (!value.has(id)) removedIds.add(id);
            });

            // a) XÓA: loại bỏ các item Manual có customerId thuộc removedIds
            const kept = prevList.filter(item => {
                // nếu bị bỏ chọn -> loại
                if (removedIds.has(item.customerId)) return false;
                return true; // còn lại giữ
            });

            // b) THÊM: thêm các id mới từ value nếu chưa có trong kept
            const byId = new Map<number, ISelectedCustomer>(kept.map(c => [c.customerId, c]));
            value.forEach(id => {
                if (!byId.has(id)) {
                    byId.set(id, { customerId: id, addType: AddType.Manual });
                }
            });

            return Array.from(byId.values());
        });

        // 2) Đồng bộ lại "bộ chọn" unmatched hiện tại
        setSelectedIdCondUnmatchedCustomers(value);
    };

    const onPaginationCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        setPaginationCustomer((prev) => ({ ...prev, current: pageNumber, pageSize }))
        gListCustomer(pageNumber, pageSize)
    }


    //xem trc ds k co dk
    const onPaginationNoCondChangeManual: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListNoCondCustomerManual(pageNumber, pageSize)
    }

    //Kh có dk
    const onPaginationChangeCondAll: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListCustomerCondAll(pageNumber, pageSize)
    }

    const onPaginationCondMatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gSyncListCustomerGroupByFilter("condMatched", pageNumber, pageSize)
    }

    const onPaginationCondUnmatchedCustomers: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gSyncListCustomerGroupByFilter("condUnmatched", pageNumber, pageSize)
    }
    const onChangeTreeSelect = (value: number, node: any) => {
        setInforGroup({ ...inforGroup, parentId: value, level: node.level })
    }

    const onSubmitFormModalSaveFilter = (iSsuccess: boolean, message?: string) => {
        if (iSsuccess) {
            setModalCondition(false)
            pushToast(message, "success")
        }
        else {
            pushToast(message, "warning")
        }
    }

    const gListOperatorFieldGroup = useDebounce(async () => {
        pushLoading(true)
        const result = await getListOperatorFieldGroup(searchListFilter
        )
        if (result?.status) {
            setSLOperatorFieldGroup(result.data)
        }
        pushLoading(false)
    }, 1000)

    // hàm xử lý select trường V2
    const options = useMemo(() => buildOptions(sLOperatorFieldGroup), [sLOperatorFieldGroup]);

    const selectableOptions = options.filter(
        (item) => !item.isGroup
    );
    // end

    const gListAllCustomer = useDebounce(async (isAllCond: boolean = true) => {
        pushLoading(true)
        if (isAllCond) {
            const result = await getListAllCustomer(permittedCategoryCarIds, unitTemp, filterInfoOperatoToConditions(infoOperator), inforGroup?.id)
            if (result?.status) {
                setSelectedIdCustomerV9(result.data);
                // Lưu snapshot KH addType=1 từ API
                initialAutoCustomersRef.current = new Set(
                    result.data
                        .filter((c: ISelectedCustomer) => c.addType === AddType.Auto)
                        .map((c: ISelectedCustomer) => c.customerId)
                );
                const manualIds = new Set(
                    result.data
                        .filter((c: ISelectedCustomer) => c.addType === AddType.Manual)
                        .map((c: ISelectedCustomer) => c.customerId)
                );
                setSelectedIdCondUnmatchedCustomers(manualIds);
            } else {
                pushToast(result?.message, "warning")
            }
        }
        pushLoading(false)
    }, 1000)

    // ds all customer
    useEffect(() => {
        if (infoOperator.typeCondition === CONDITIONGROUP.ALL) gListAllCustomer()
    }, [unitTemp, infoOperator.typeCondition])

    //Kh có dk khi thêm thủ công
    useEffect(() => {
        if (inforGroup.type === CONDITION.YES) {
            setIsModalLoadingSync(true)
            gSyncListCustomerGroupByFilter("condUnmatched")
            setIsModalLoadingSync(false)

        }
    }, [dataFilterListCondUnmatchedCustomers])

    //Kh có dk khi thêm thủ công
    useEffect(() => {
        if (skipCondMatchedRef.current) return;
        if (inforGroup.type === CONDITION.YES) {
            setIsModalLoadingSync(true)
            gSyncListCustomerGroupByFilter("condMatched")
            setIsModalLoadingSync(false)

        }
    }, [selectedIdCondUnmatchedCustomers])

    useEffect(() => {
        if (inforGroup?.id && inforGroup?.type === CONDITION.NO) {
            gListCustomer()
        }
    }, [inforGroup?.id, inforGroup?.type, dataFilterListNoCondCustomers, selectedIdNoCondCustomerManual])

    //Kh không dk
    useEffect(() => {
        if (inforGroup?.id && inforGroup?.type === CONDITION.NO) {
            // gListNoCondCustomerManual()
        } else {
            setSelectedIdNoCondCustomerManual(new Set([]))
        }
    }, [inforGroup?.id, inforGroup?.type, dataFilterListNoCondCustomerManual])



    useEffect(() => {
        gListOperatorFieldGroup()
    }, [searchListFilter])

    useEffect(() => {
        if (!sLOperatorFieldGroup.length && isModalCondition)
            gListOperatorFieldGroup()
    }, [isModalCondition])


    // /fix 

    // hàm xử lý khi chọn tất cả KH
    useEffect(() => {
        // bất tắt switch áp dụng điều kiện 
        const conditions = infoOperator.conditions.filter((a) => a.isAdd === true)

        if (inforNodeEvent?.action === "update" && !conditions.length) {
            return;
        }

        // ── Edit tracking: phân biệt initial load vs user change ──
        if (isInitialCondLoadRef.current) {
            isInitialCondLoadRef.current = false;
            initialConditionRef.current = serializeConditions(infoOperator);
        } else {
            // User đã thay đổi condition → set modified
            setIsCustomerModified(true);
        }

        setInforGroup(prev => ({
            ...prev,
            type: conditions.length ? CONDITION.YES : CONDITION.NO
        }))
        // hàm xử lý khi thay đổi đk thành AND - OR
        if (conditions.length) {
            setIsModalLoadingSync(true)

            // Bật cờ để không cho A tự động bắn condMatched do reset
            skipCondMatchedRef.current = true;

            //Xóa các trường đã chọn khi thay đổi đk
            setSelectedIdCondUnmatchedCustomers(new Set())
            setSelectedIdCustomerV9([])
            setSelectedIdAccount([])

            gSyncListCustomerGroupByFilter("filter")
            gListAllCustomer(false)
            setIsModalLoadingSync(false)
        }
    }, [infoOperator.conditions])

    // hàm xử lý khi chọn tất cả KH
    useEffect(() => {
        // bất tắt switch áp dụng điều kiện 
        if (infoOperator.typeCondition === CONDITIONGROUP.ALL) {
            gListCustomerCondAll()
            setInforGroup(prev => ({
                ...prev,
                type: CONDITION.YES
            }))
        }

    }, [infoOperator.typeCondition])

    useEffect(() => {
        //Xóa ds điều kiện
        if (inforGroup.type === CONDITION.NO) {
            setInfoOperator(initInfoOperator)
        } else {
            // setSelectedIdCustomer(new Set([]))
            // setSelectedIdCustomerV9([])
        }
        //Xóa ds khách hàng đã chọn
        // 
    }, [inforGroup.type])

    useEffect(() => {
        if (inforNodeEvent?.action === "update" && inforNodeEvent.item?.key) {
            gInforGroup(Number(inforNodeEvent.item.key), Number(unitTemp))
        } else {
            setInforGroup(initDetailGroup)
            setInfoOperator(initInfoOperator)
        }
    }, [inforNodeEvent])


    return (
        <div className={`custom-page-css w-full flex flex-col relative ${displayType === EDisplayGroupType.TREE ? 'py-3 pr-3 pl-1' : ''} `}>
            <ModalAddAndEditCondition
                isOpen={isModalCondition}
                selectableOptions={selectableOptions}
                options={options}

                onSubmitFormModal={onSubmitFormModalSaveFilter}
                closeModal={setModalCondition}

                // moi
                infoOperator={infoOperator}
                setInfoOperator={setInfoOperator}
                setSearchListFilter={setSearchListFilter}
            />
            <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4  rounded">
                <div className="custom-page-css w-full flex items-center justify-between">
                    <div className="custom-page-css w-full flex items-center gap-2 ">
                        <span className='custom-page-css text-base font-regular w-100px'>Loại nhóm</span>
                        <div className={`${inforGroup?.status === GROUPTYPE.PRIVATE ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
                            onClick={() => setInforGroup({ ...inforGroup, status: GROUPTYPE.PRIVATE })}>
                            <div className="custom-page-css flex items-center justify-center">
                                <img src={inforGroup?.status === GROUPTYPE.PRIVATE ? user_private_active : user_private} alt="" />
                            </div>
                            <span
                                className={`${inforGroup?.status === GROUPTYPE.PRIVATE ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
                            >
                                Nhóm riêng tư
                            </span>
                        </div>
                        <div
                            className={`${inforGroup?.status === GROUPTYPE.SHARED ? 'border-91D5FF bg-E6F7FF' : 'border'} custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
                            onClick={() => setInforGroup({ ...inforGroup, status: GROUPTYPE.SHARED })}>
                            <div className="custom-page-css flex items-center justify-center">
                                <img src={inforGroup?.status === GROUPTYPE.SHARED ? group_share_active : group_share} alt="" />
                            </div>
                            <span
                                className={`${inforGroup?.status === GROUPTYPE.SHARED ? 'text-1890FF' : 'text-98A2B3'} custom-page-css text-base  font-regular`}
                            >
                                Nhóm có thể chia sẻ
                            </span>
                        </div>
                    </div>
                    <div className="custom-page-css flex items-center gap-2">
                        <span className='custom-page-css text-base font-regular whiteSpace-nowrap'>Tự động thêm khách hàng có cùng điều kiện</span>
                        <Switch
                            checked={inforGroup.type === CONDITION.YES ? true : false}
                            onClick={() => handleSwitch(inforGroup?.type)}
                        />

                    </div>
                </div>
                <div className="custom-page-css w-full flex items-center gap-2 ">
                    <span className='custom-page-css text-base font-regular w-100px shrink-0'>Tên nhóm</span>
                    {/* <div className={` custom-page-css flex items-center gap-2 border rounded px-2 py-1 cursor-pointer`}>
                        <input
                            placeholder='Nhập tên nhóm'
                            className='custom-page-css outline-none border-none '
                            value={inforGroup?.title}
                            onChange={(e) => handleChange("title", e.target.value)}
                        />
                    </div> */}

                    <TextArea
                        placeholder='Nhập tên nhóm'
                        className='custom-page-css w-full  '
                        value={inforGroup?.title}
                        onChange={(e) => handleChange("title", e.target.value)}
                    />

                </div>
                <div className="custom-page-css w-full flex items-start gap-2 ">
                    <span className='custom-page-css text-base font-regular w-100px shrink-0'>Mô tả</span>
                    <TextArea
                        placeholder='Nhập mô tả'
                        className='custom-page-css w-full  '
                        value={inforGroup?.description}
                        onChange={(e) => handleChange("description", e.target.value)}
                    />

                </div>

                <div className="custom-page-css w-full flex items-start gap-2 ">
                    <span className='custom-page-css text-base font-regular w-100px shrink-0'>Nhóm chính</span>
                    <TreeSelect

                        className='custom-page-css w-full  border rounded'
                        style={{ width: '100%' }}
                        value={inforGroup.parentId === 0 ? undefined : inforGroup.parentId}
                        styles={{
                            popup: { root: { maxHeight: 400, overflow: 'auto' } },
                        }}
                        placeholder="Chọn nhóm chính"
                        allowClear

                        treeDefaultExpandAll
                        onSelect={onChangeTreeSelect}
                        treeData={removeNodeById(convertTreeForAntd(listGroup), inforGroup.id)}
                    // onPopupScroll={onPopupScroll}
                    />

                </div>
            </div>

            <div className={inforGroup?.type === CONDITION.YES ? '' : 'd-none'}>
                <EG_ConditionComponent
                    isLoadingTableModal={isLoadingTableModal}
                    memoizedColumnDefs={memoizedColumnDefs}
                    infoOperator={infoOperator}
                    inforGroup={inforGroup}

                    // selectedIdCustomer={selectedIdCustomer}
                    selectedIdCustomerV9={selectedIdCustomerV9}
                    selectedIdAccount={selectedIdAccount}

                    // setSelectedIdCustomer={setSelectedIdCustomer}
                    setSelectedIdCustomerV9={handleChangeCondSelectIdCustomerView}

                    setSelectedIdAccount={setSelectedIdAccount}

                    //Kh có dk
                    dataFilterListCondUnmatchedCustomers={dataFilterListCondUnmatchedCustomers}

                    paginationCondMatchedCustomers={paginationCondMatchedCustomers}
                    paginationCondUnmatchedCustomers={paginationCondUnmatchedCustomers}

                    selectedIdCondUnmatchedCustomers={selectedIdCondUnmatchedCustomers}

                    tableDataCondMatchedCustomers={tableDataCondMatchedCustomers}
                    tableDataCondUnmatchedCustomers={tableDataCondUnmatchedCustomers}

                    tableDataNoCondCustomer={tableDataNoCondCustomer}

                    setModalCondition={setModalCondition}

                    setDataFilterListCondUnmatchedCustomers={setDataFilterListCondUnmatchedCustomers}

                    onPaginationCondUnmatchedCustomers={onPaginationCondUnmatchedCustomers}
                    onPaginationCondMatchedCustomers={onPaginationCondMatchedCustomers}

                    setSelectedIdCondUnmatchedCustomers={handleChangeCondSelectIdCustomerManual}

                    //Kh có dk

                    //Kh có dk All
                    tableDataCondCustomerAll={tableDataCondCustomerAll}
                    paginationCondAll={paginationCondAll}
                    onPaginationChangeCondAll={onPaginationChangeCondAll}
                //Kh có dk All
                />
            </div>
            <>
                <div className={(inforGroup?.type === CONDITION.NO && inforGroup?.status === GROUPTYPE.PRIVATE) ? '' : 'd-none'}>
                    <EG_PrivateNoAutomatic
                        sLCategoryCar={sLCategoryCar}
                        paginationCustomer={paginationCustomer}

                        memoizedColumnDefs={memoizedColumnDefs}
                        // selectedIdCustomer={selectedIdCustomer}
                        selectedIdCustomerV9={selectedIdCustomerV9}

                        onPaginationCustomers={onPaginationCustomers}

                        setSelectedIdCustomerV9={handleChangeNoCondSelectIdCustomerView}
                        //Kh không dk
                        paginationNoCondCustomerManual={paginationNoCondCustomerManual}

                        dataFilterListNoCondCustomers={dataFilterListNoCondCustomers}
                        dataFilterListNoCondCustomerManual={dataFilterListNoCondCustomerManual}

                        tableDataNoCondCustomer={tableDataNoCondCustomer}

                        selectedIdNoCondCustomerManual={selectedIdNoCondCustomerManual}
                        tableDataNoCondCustomerManual={tableDataNoCondCustomerManual}


                        setDataFilterListNoCondCustomers={setDataFilterListNoCondCustomers}
                        setDataFilterListNoCondCustomerManual={setDataFilterListNoCondCustomerManual}
                        onPaginationNoCondChangeManual={onPaginationNoCondChangeManual}
                        handleChangeNoCondSelectIdCustomerManual={handleChangeNoCondSelectIdCustomerManual}

                    //Kh không dk


                    />
                </div>

                <div className={(inforGroup?.type === CONDITION.NO && inforGroup?.status === GROUPTYPE.SHARED) ? '' : 'd-none'}>
                    <EG_SharingNoAutomatic
                        memoizedColumnDefs={memoizedColumnDefs}
                        inforGroup={inforGroup}

                        sLCategoryCar={sLCategoryCar}

                        // selectedIdCustomer={selectedIdCustomer}
                        selectedIdCustomerV9={selectedIdCustomerV9}

                        selectedIdAccount={selectedIdAccount}
                        setSelectedIdCustomerV9={handleChangeNoCondSelectIdCustomerView}

                        paginationCustomer={paginationCustomer}

                        setSelectedIdAccount={setSelectedIdAccount}
                        onPaginationCustomers={onPaginationCustomers}
                        //Kh không dk
                        tableDataNoCondCustomer={tableDataNoCondCustomer}
                        dataFilterListNoCondCustomers={dataFilterListNoCondCustomers}
                        dataFilterListNoCondCustomerManual={dataFilterListNoCondCustomerManual}

                        paginationNoCondCustomerManual={paginationNoCondCustomerManual}

                        selectedIdNoCondCustomerManual={selectedIdNoCondCustomerManual}
                        tableDataNoCondCustomerManual={tableDataNoCondCustomerManual}

                        setDataFilterListNoCondCustomers={setDataFilterListNoCondCustomers}

                        setDataFilterListNoCondCustomerManual={setDataFilterListNoCondCustomerManual}
                        onPaginationNoCondChangeManual={onPaginationNoCondChangeManual}
                        handleChangeNoCondSelectIdCustomerManual={handleChangeNoCondSelectIdCustomerManual}

                    //Kh không dk

                    />
                </div>
            </>
            <div className="custom-page-css w-full flex items-center justify-end gap-2">
                <div className={` border-F5222D bg-FFF1F0 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer`}
                    onClick={cancelUpdateGroup}
                >
                    <CloseOutlined className='text-F5222D' />
                    <span className={` custom-page-css text-F5222D text-base  font-regular`}>Huỷ bỏ</span>
                </div>
                <div
                    className={`${isLoading ? "d-none" : ""} bg-096DD9  border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-1 cursor-pointer `}
                    onClick={updateGroup}
                >
                    <CheckOutlined className='text-white' />
                    <span className={`custom-page-css  text-white  font-regular`}>
                        Lưu nhóm
                    </span>
                </div>
            </div>
        </div>
    )
}
export default memo(EditGroup) 
